import React from 'react';
import { ThemeProvider } from '@theme-ui/core';

import { nearMeCheckTheme } from 'src/theme';

type AppThemeProviderProps = WhitelabelOverrides & {
    children: React.ReactNode;
};

type WhitelabelOverrides = {
    colorButtonBackground?: string;
    colorSuccess?: string;
    colorFailure?: string;
    mainBackgroundColor?: string;
    secondaryBackgroundColor?: string;
    textColor?: string;
    fontFamily?: string;
};

function getWhitelabelledTheme({
    colorButtonBackground,
    colorSuccess,
    colorFailure,
    mainBackgroundColor,
    secondaryBackgroundColor,
    textColor,
    fontFamily,
}: WhitelabelOverrides) {
    const { whitelabel } = nearMeCheckTheme.colors;

    return {
        ...nearMeCheckTheme,
        colors: {
            ...nearMeCheckTheme.colors,
            nearMeCheck: {
                ...nearMeCheckTheme.colors.nearMeCheck,
                // Override main background color (white)
                ...(mainBackgroundColor && { white: mainBackgroundColor }),
                // Override secondary background color (grey.0)
                grey: {
                    ...nearMeCheckTheme.colors.nearMeCheck.grey,
                    ...(secondaryBackgroundColor && { 0: secondaryBackgroundColor }),
                    // Override text color (grey.rich)
                    ...(textColor && { rich: textColor }),
                },
            },
            whitelabel: {
                ...whitelabel,
                buttonBackground: colorButtonBackground || whitelabel.buttonBackground,
                buttonHoverBackground: colorButtonBackground || whitelabel.buttonHoverBackground,
                buttonActiveBackground: colorButtonBackground || whitelabel.buttonActiveBackground,
                success: colorSuccess || whitelabel.success,
                failure: colorFailure || whitelabel.failure,
            },
        },
        // Override font family for body text if provided
        ...(fontFamily && {
            fonts: {
                ...nearMeCheckTheme.fonts,
                normal: fontFamily,
            },
        }),
    };
}

export function AppThemeProvider({ children, ...whitelabelOverrides }: AppThemeProviderProps) {
    const whitelabelledTheme = getWhitelabelledTheme(whitelabelOverrides);

    return <ThemeProvider theme={whitelabelledTheme}>{children}</ThemeProvider>;
}
